/**
 * 原始写法:
 * <script async src="https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID"></script>
 * <script>
 * window.dataLayer = window.dataLayer || [];
 * function gtag(){dataLayer.push(arguments);}
 * gtag('js', new Date());
 * gtag('config', 'GA_MEASUREMENT_ID');
 * </script>
 * gtag('config', 'GA_MEASUREMENT_ID', { 'send_page_view': false });
 *
 */

import { EPlatform } from '@/api/app';
import { ESubscribeMode } from '@reolink-cloud/interface';
import { config } from 'CONFIG';

interface IGAConfig {
    client: EPlatform;
}

class GA {

    private readonly client: EPlatform;

    public href: string = '';

    public accountId: string = '';

    public subscribeMode: ESubscribeMode = ESubscribeMode.CREATE;

    public prevPlan: string = '';

    public nextPlan: string = '';

    /**
     * Creates an instance of GA.
     * @param config 配置
     * @memberof GA
     */
    public constructor( config: IGAConfig ) {

        this.client = config.client;
        this.init();

    }

    /**
     * 初始化 gtag 函数
     *
     * @returns void
     * @memberof GA
     */
    public init(): void {

        this.bindEvent();

    }

    /**
     * 更新当前页面信息
     *
     * @param {*} pageName 页面名称
     * @param {*} newPath 页面path
     * @memberof GA
     */
    public updateLocation( pageName: string, newPath: string ): void {

        this.href = newPath;
        window.gtag( 'config', this.accountId, {
            'page_title': pageName,
            'page_path': newPath,
            // page_location 的含义在这里是平台名称，可能有三种值： IOS/Android/Web
            'page_location': this.client
        });

    }

    /**
     * 发送包含client和path的pageview事件
     * @memberof GA
     */
    public pageview(): void {

        window.gtag( 'event', 'pageView', {
            'event_category': this.client,
            'event_label': this.href
        });

    }

    public sendEvent( type: string, category: string ): void {

        try {

            window.gtag( 'event', `${type}(in ${this.client})`, {
                'event_category': category,
                'event_label': this.href
            });

        } catch ( err ) {

            console.error( err );

        }

    }

    /**
     * 发送简单GA事件，其中事件名称跟分类同名
     * @param type 事件名称
     */
    public sendSimpleEvent( type: string ): void {

        try {

            window.gtag( 'event', `${type}(in ${this.client})`, {
                'event_category': type,
                'event_label': this.href
            });

        } catch ( err ) {

            console.error( err );

        }

    }

    public sendECommerceEvent( type: string, data: any ): void {

        try {

            window.gtag( 'event', type, data );

        } catch ( err ) {

            console.error( err );

        }

    }

    public sendSubscribeMode(): void {

        if ( !this.subscribeMode ) {

            return;

        }
        let label = this.nextPlan;
        if ( this.subscribeMode === ESubscribeMode.SWITCH ) {

            label = `${this.prevPlan} to ${label}`;

        }
        this.sendEvent( this.subscribeMode, label );

    }

    public sendCalculateTax( status: string = '' ): void {

        const label = status;
        this.sendEvent( 'calculateTax', label );

    }

    public bindEvent(): void {

        const _this = this;
        $( 'body' ).on( 'click', '[ga-label]', e => {

            const label = $( e.target ).attr( 'ga-label' ) ?? '';
            _this.sendEvent( 'click', label );

        });

    }

    public sendFreeOfferEvent( label: string = '' ): void {

        this.sendEvent( 'freeOffer', label );

    }

}

export default new GA(
    {
        client: config.client
    }
);
